// Toolbar for the admin pricing matrix: free-text search and a category
// multi-select chip group. Controlled — `value` and `onChange` come from the
// page so the matrix table can read the same filter state.
import {
  Box, TextField, InputAdornment, Stack, Chip, Typography,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import SaveStatusPill from './SaveStatusPill.jsx';

const PricingMatrixToolbar = ({
  search, onSearchChange, categories, selectedCategoryIds, onToggleCategory, onSave,
}) => (
  <Box sx={{
    display: 'flex',
    gap: 2,
    alignItems: { xs: 'stretch', md: 'center' },
    flexDirection: { xs: 'column', md: 'row' },
    flexWrap: 'wrap',
    minWidth: 0,
    maxWidth: '100%',
    mb: 2,
  }}
  >
    <TextField
      value={search}
      onChange={(e) => onSearchChange(e.target.value)}
      placeholder="Search products and options"
      size="small"
      sx={{ minWidth: 260, flex: 1 }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        },
        htmlInput: { 'aria-label': 'Search products and options' },
      }}
    />

    <Stack
      direction="row"
      spacing={1}
      useFlexGap
      sx={{
        alignItems: 'center', flexWrap: 'wrap', flex: 1, minWidth: 0,
      }}
    >
      <Typography variant="body2" color="text.secondary" sx={{ mr: 0.5 }}>
        Categories:
      </Typography>
      {categories.length === 0 && (
        <Typography variant="body2" color="text.secondary">No categories yet.</Typography>
      )}
      {categories.map((category) => {
        const selected = selectedCategoryIds.includes(category.id);
        return (
          <Chip
            key={category.id}
            label={category.name}
            color={selected ? 'primary' : 'default'}
            variant={selected ? 'filled' : 'outlined'}
            onClick={() => onToggleCategory(category.id)}
            size="small"
            aria-pressed={selected}
          />
        );
      })}
    </Stack>

    <Box sx={{ flexGrow: 0, ml: { md: 'auto' } }}>
      <SaveStatusPill onSave={onSave} />
    </Box>
  </Box>
);

export default PricingMatrixToolbar;
